import React from 'react';
import homeImg from '../Assets/homeImage.jpg';
import MZAS_LOGO from '../Assets/MZAS_LOGO.svg';

function Home() {
    return (
        <section className="home">
            <div className="home__left">
                <div className="home__left__img">
                    <img className="home__left__img__background" src={homeImg} alt="" />
                    <div className="home__left__img__logo">
                        <img className="home__left__img__logo__logo" data-aos="fade-right" src={MZAS_LOGO} alt="MZAS LOGO" />
                    </div>
                </div>
            </div>
            
            <div className="home__right">
                <h1 className="home__right__name" data-aos="flip-up" data-aos-delay="100" >
                    MZAS ENGINEERING COMPANY
                </h1>
                <span className="home__right__limited" data-aos="fade-down" data-aos-delay="200" >
                    SMC-PRIVATE LIMITED
                </span>
                {/* <p className="home__right__quote" data-aos="zoom-in">
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Commodi culpa temporibus alias, voluptatem ratione quae porro molestias inventore numquam repellendus.
                </p> */}
            </div>
        </section>
    )
}

export default Home;
